<script>
	export let image = "";
	export let position = "center";
	export let small = false;
</script>

<div class="UICover" class:_small={small}>
	<div
		class="UICoverImage"
		style="background-image:url({image});background-position:center {position}"
	/>
	<div class="UICoverBox">
		<slot />
	</div>
</div>

<style global>
	.UICover {
		background-color: #bbb;
		background-repeat: no-repeat;
		background-position: center;
		background-size: cover;
		height: 400px;
		position: relative;
	}
	.UICover._small {
		height: 240px;
	}
	.UICoverImage {
		position: absolute;
		z-index: 1;
		width: 100%;
		height: 100%;
		background-repeat: no-repeat;
		background-size: cover;
		filter: brightness(75%);
	}
	.UICoverBox {
		position: absolute;
		text-align: center;
		z-index: 1;
		width: 100%;
		top: 50%;
		transform: translateY(-50%);
		padding: 1em;
	}
</style>
